<!--  -->
<template>
  <div class="recharge-nav-bar" :style="[style_bgc, style_bg, style_fixed]">
    <div class="left" :style="{ color: fontColor }" @click="leftBack">
      <van-icon name="arrow-left" :style="{ color: fontColor }" />
    </div>
    <div class="title" :style="{ color: fontColor }" v-if="titleText">{{ titleText }}</div>
    <div class="right" :style="{ color: fontColor }" v-if="rightText" @click="rightTextEvent">
      {{ rightText }}
    </div>
  </div>
</template>



<script>
export default {
  name: "navBar",
  data() {
    return {
      
    };
  },
  props: {
    titleText: {
      type: String
    },
    rightText: {
      type: String
    },
    fontColor: {
      type: String,
      defult: "#ffffff",
    },
    bgc: {
      type: String
    },
    bg: {
      type: String
    },
    isFixed: {
      type: Boolean,
      default: false,
    },
    isIOSX: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    style_bgc: function(){
      return {
        'background-color': this.bgc
      }
    },
    style_bg: function(){
      return {
        'background': this.bg
      }
    },
    style_fixed: function(){
      return this.isFixed ? {
        position: 'fixed',
        top: 0,
        'z-index': 100,
        padding: this.isIOSX ? '71px 0 8px': '51px 0 8px',
      } : {}
    },
  },
  methods: {
    leftBack(){
      this.$emit('goBack')
    },
    rightTextEvent(){
      this.$emit('rightTextEvent')
    }

  },
};
</script>

<style scoped lang='less'>

.recharge-nav-bar {
  position: relative;
  width: 100%;
  background: #fff;
  // height: 44px;
  display: flex;
  align-items: center;
  padding: 7px 0 8px;
  .left {
    position: absolute;
    left: 0;
    padding: 0 16px;
    display: flex;
    align-items: center;
    font-size: 18px;
    .van-icon  {
      font-weight: 600;
    }
    
  }
  .title {
    width: 100%;
    height: 29px;
    line-height: 29px;
    text-align: center;
    font-size:18px;
    font-weight:700!important;
  }
  .right {
    position: absolute;
    right: 0;
    padding: 0 16px;
    font-weight: 500;
  }
}
</style>
